import { Head } from "@inertiajs/react";

// Keeps the browser-tab title in sync during client-side (SPA) navigation.
//
// The crawler- and social-sharer-facing SEO — meta description, canonical,
// hreflang, Open Graph, Twitter cards, and JSON-LD — is rendered server-side by
// Rails (app/views/shared/_page_seo.html.erb via the controller's @page_seo),
// because Inertia SSR is disabled and non-JS crawlers only see the server HTML.
const SeoHead = ({ title, description }) => {
  return (
    <Head title={title}>
      <meta
        head-key="description"
        name="description"
        content={description || ""}
      />
    </Head>
  );
};

export default SeoHead;
